import React from "react";

interface Props {
    children: React.ReactNode;
    customMessage?: boolean;
}

export function ErrorMessage({ children, customMessage }: Props) {
    return (
        <div className="grid justify-items-center sm:flex sm:justify-center grid-cols-1 col-span-2 gap-2 bg-red-300 p-1 border-2 border-red-400 rounded-lg text-red-700 font-semibold">
            {customMessage == null 
            ? <>
                <p>Un problema ha ocurrido.</p>
                <p>{children}</p>
            </>
            :
            <>
                <p>{children}</p>
            </>
            }
        </div>
    );
}
